/* eslint no-unused-vars:0 */

import axios from 'axios';

export const advisor = {
    namespaced: true,

    state: {
        advisor: {},
    },

    actions: {
        loadAdvisor ({ commit, getters, rootGetters }) {
            return axios
                .get('/api/household/' + rootGetters['auth/user'].household_id + '/advisor')
                .then(response => {
                    commit('setAdvisor', response.data.data.advisor);
                    return response;
                })
        },
    },

    mutations: {
        setAdvisor(state, advisor) {
            state.advisor = advisor;
        }
    },

    getters: {
    }
}
